import React from "react";

import {
  CodeCellIcon,
  EyeOpenIcon,
  NewThreadIcon,
  NotebookViewIcon,
} from "../icons/CustomIcons";

/** Stable view ids for plain-code project shell tabs (do not rename). */
export const TAO_PROJECT_VIEW = {
  chat: "chat",
  notebook: "notebook",
  code: "code",
  preview: "preview",
} as const;

export type TaoProjectView =
  (typeof TAO_PROJECT_VIEW)[keyof typeof TAO_PROJECT_VIEW];

export type TaoProjectViewDefinition = {
  readonly id: TaoProjectView;
  readonly label: string;
  readonly icon: React.ReactElement;
};

export const TAO_PROJECT_VIEW_DEFINITIONS: ReadonlyArray<TaoProjectViewDefinition> =
  [
    {
      id: TAO_PROJECT_VIEW.chat,
      label: "Chat",
      icon: <NewThreadIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.notebook,
      label: "Notebook",
      icon: <NotebookViewIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.code,
      label: "Code",
      icon: <CodeCellIcon />,
    },
    {
      id: TAO_PROJECT_VIEW.preview,
      label: "Preview",
      icon: <EyeOpenIcon />,
    },
  ];

export const DEFAULT_TAO_PROJECT_OPEN_VIEWS: ReadonlyArray<TaoProjectView> = [
  TAO_PROJECT_VIEW.chat,
];

export const TAO_PROJECT_SCREENSHOT_OPEN_VIEWS: ReadonlyArray<TaoProjectView> =
  [TAO_PROJECT_VIEW.preview];

/** Max content width for the Chat tab agent UI (matches logic-view fullscreen threads). */
export const TAO_PROJECT_FULLSCREEN_CHAT_CONTENT_MAX_WIDTH = 760;
